// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3JGb0","AuthForm":"Auth_AuthForm__2gfF4"};